import React from 'react'; // Added React import for forwardRef
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as s from './badge.css';
import { Typography } from '../typography/typography';

type BadgeProps = {
  label: string;
  color?: 'primary' | 'secondary' | 'success' | 'warning' | 'error';
  startIcon?: IconProp;
  endIcon?: IconProp;
  iconClassName?: string;
};

export const Badge = React.forwardRef<HTMLDivElement, BadgeProps>((p, ref) => {
  const { startIcon, label, iconClassName } = p;
  return (
    <div
      {...p}
      ref={ref}
      className={`${s.badge} ${startIcon ? s.badgeWithIcon : ''}`}
    >
      {startIcon && (
        <FontAwesomeIcon icon={startIcon} className={iconClassName} />
      )}
      <Typography size="small" variant="body" className={s.textWrapper}>
        {label}
      </Typography>
    </div>
  );
});
